import type { AgencyView } from '@/api/types'

/**
 * Apply a tenant's brand onto the Tailwind theme CSS variables at runtime, recolouring the
 * whole UI live. Passing null (or missing colours) clears the overrides back to the
 * ProfitPipe defaults defined in index.css.
 */
export function applyBrand(agency: AgencyView | null) {
  const root = document.documentElement
  const set = (name: string, value: string | null | undefined) => {
    if (value) root.style.setProperty(name, value)
    else root.style.removeProperty(name)
  }
  set('--color-brand-primary', agency?.brandColor)
  set('--color-brand-darkest', agency?.brandColorDark ?? agency?.brandColor)
  set('--color-brand-dark', agency?.brandColorDark ?? agency?.brandColor)
  set('--color-brand-bg', agency?.brandColor50)
}
